import { initSentry } from '@mopla/logger';

import { environment } from '../environments/environment';

export const initDriverSentry = () =>
	initSentry({
		dsn: environment.sentryDns,
		environment: environment.env,
		tracePropagationTargets: [environment.baseUrl],
		appName: 'driver',
	});
